import React from 'react';
import './loader.css'
type LoaderSizeKey = 'XLARGE' | 'LARGE' | 'MEDIUM' | 'SMALL' | 'XSMALL';
type Size = { width: string; height: string };
const loaderSizes: Record<LoaderSizeKey, Size> = {
  XLARGE: { width: '2.8rem', height: '2.8rem' },
  LARGE: { width: '2.4rem', height: '2.4rem' },
  MEDIUM: { width: '2rem', height: '2rem' },
  SMALL: { width: '1rem', height: '1rem' },
  XSMALL: { width: '0.5rem', height: '0.5rem' },
};

interface Props{
    loaderSize:LoaderSizeKey;
    bgColor?: string;
}

const Loader = ({loaderSize,bgColor = 'white'}:Props) => {
  const style: React.CSSProperties = {
    ...loaderSizes[loaderSize],
    '--uib-color': bgColor, // sätt bakgrundsfärgen på dot:arna
  } as React.CSSProperties;
  return (
    <div className="dot-spinner" style={style}>
        {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="dot-spinner__dot"  />
      ))}
      </div>
  );
}


export default Loader;
